import React from 'react';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function PlanoDeContasAdd({ setOption }) {
  return (
    <div>
      <ContainerSection>
        <h3>Incluir</h3>
        <div>
          <WrapperInputsNewSystem>
            <InputText title="Código da Conta" id="CodigoDaConta" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Descrição" id="Descricao" widthPercentage="50%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Origem "
              id="Origem "
              optionsArray={['', 'Devedora', 'Credora']}
              widthPercentage="50%"
            />
          </WrapperInputsNewSystem>
        </div>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
    </div>
  );
}
